// Measure only on a fresh confirmed ball. The source follows the contained
// studio image (including letterboxing) or the closed-view cage, never the page.
export function ballFlightFrames(node:HTMLElement,style:CSSStyleDeclaration):Keyframe[]{
 const end=node.getBoundingClientRect(),scene=node.closest('.room-scene');
 const media=scene?.classList.contains('video-on')?scene.querySelector<HTMLImageElement|HTMLVideoElement>('.room-scene-media img,.room-scene-media video'):null;
 const cage=scene?.querySelector('[data-ball-origin]');
 let dx=16,dy=-Math.max(60,end.height);
 if(media){
  const box=media.getBoundingClientRect();
  const width=media instanceof HTMLImageElement?media.naturalWidth:media.videoWidth;
  const height=media instanceof HTMLImageElement?media.naturalHeight:media.videoHeight;
  // The current broadcast uses object-fit:contain. Before media is ready, use
  // its frame; loading the asset must not start or replay a confirmed cue.
  const scale=width>0&&height>0?Math.min(box.width/width,box.height/height):1;
  const w=width>0?width*scale:box.width,h=height>0?height*scale:box.height;
  const percent=(key:string,fallback:number)=>{const n=parseFloat(style.getPropertyValue(key));return Number.isFinite(n)?Math.max(0,Math.min(100,n))/100:fallback;};
  dx=box.left+(box.width-w)/2+w*percent('--room-ball-origin-x',.14)-(end.left+end.width/2);
  dy=box.top+(box.height-h)/2+h*percent('--room-ball-origin-y',.58)-(end.top+end.height/2);
 }else if(cage){
  const box=cage.getBoundingClientRect();dx=box.left+box.width/2-(end.left+end.width/2);dy=box.top+box.height/2-(end.top+end.height/2);
 }
 // Both origins use one decelerating flight, without scale overshoot or landing bounce.
 const transform=(x:number,y:number,scale:number)=>`translate(${x}px, ${y}px) scale(${scale})`;
 return [
  {transform:transform(dx,dy,.35),opacity:.5,filter:'brightness(1.15)',offset:0,easing:'cubic-bezier(.22,.61,.36,1)'},
  {transform:transform(0,0,1),opacity:1,filter:'brightness(1)',offset:1}
 ];
}
